import React, { useState, useEffect } from 'react';
import { AnnoNode, Annotation } from '../../domain/domain';
import AnnotationTreeView from "./AnnotationTreeView";
import FullScreenProgress from '../FullScreenProgress/FullScreenProgress';

type Props = {
    selectedNodeId: number | undefined,
    treeRoot: Annotation,
    onNodeClicked: (node: AnnoNode) => void,
}

const AnnotationTreePanel: React.FC<Props> = ({ selectedNodeId, treeRoot, onNodeClicked }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (treeRoot === undefined || loading) {
        return <FullScreenProgress />;
    }

    return (
        <>
            {
                loading ? (
                    <FullScreenProgress />
                ) : (
                    <AnnotationTreeView
                        selectedNodeId={selectedNodeId}
                        root={treeRoot}
                        onNodeClicked={onNodeClicked}
                    />
                )
            }
        </>
    )
}

export default AnnotationTreePanel;
